var map = {
	"./AddressGradient.vue": 78883,
	"./Analytics.vue": 47015,
	"./Apple.vue": 7910,
	"./Appointment.vue": 89780,
	"./ArrowLeft.vue": 81174,
	"./ArrowRight.vue": 5005,
	"./Billing.vue": 27732,
	"./Burger.vue": 71912,
	"./ButtonShape.vue": 563,
	"./Calendar.vue": 91808,
	"./CategoryGradient.vue": 53713,
	"./Check.vue": 19046,
	"./ChevronDown.vue": 9134,
	"./ChevronLeft.vue": 80013,
	"./ChevronLeftExcenter.vue": 6188,
	"./ChevronRight.vue": 4734,
	"./ChevronUp.vue": 55012,
	"./CircleCheck.vue": 12956,
	"./CircleCheckBig.vue": 87712,
	"./CircleFadingPlus.vue": 44338,
	"./CircleX.vue": 13737,
	"./Clinic.vue": 18117,
	"./Clock.vue": 22369,
	"./ClockGradient.vue": 58679,
	"./Close.vue": 15420,
	"./CloseRed.vue": 13418,
	"./Comment.vue": 10278,
	"./CommentGradient.vue": 12532,
	"./Copy.vue": 45205,
	"./CornerRight.vue": 97852,
	"./Date.vue": 39571,
	"./DateGradient.vue": 17019,
	"./Dislike.vue": 13066,
	"./DocumentText.vue": 19484,
	"./DocumentTextGradient.vue": 10666,
	"./Dots.vue": 20700,
	"./Download.vue": 7238,
	"./Drag.vue": 89362,
	"./Dropzone.vue": 63126,
	"./Edit.vue": 79712,
	"./Ellipsis.vue": 29366,
	"./Export.vue": 5165,
	"./ExternalLink.vue": 20018,
	"./Eye.vue": 68879,
	"./EyeGradient.vue": 37350,
	"./EyeSlash.vue": 38081,
	"./Facebook.vue": 64028,
	"./FacebookSocial.vue": 62398,
	"./Facility.vue": 48154,
	"./Filter.vue": 87994,
	"./FilterClose.vue": 10909,
	"./FilterSettings.vue": 15013,
	"./FilterX.vue": 94102,
	"./Global.vue": 42074,
	"./GlobalSearch.vue": 93964,
	"./Google.vue": 29178,
	"./Headset.vue": 44188,
	"./Heart.vue": 44479,
	"./Home.vue": 43133,
	"./Hospital.vue": 64988,
	"./ImagePlaceholder.vue": 32348,
	"./Info.vue": 10312,
	"./InfoCircle.vue": 67819,
	"./Like.vue": 8965,
	"./Link.vue": 24308,
	"./Linkedin.vue": 52677,
	"./Location.vue": 74320,
	"./Logout.vue": 11005,
	"./Mail.vue": 59624,
	"./MailOpen.vue": 1556,
	"./MailSimple.vue": 32645,
	"./Menu.vue": 22953,
	"./MessageQuestion.vue": 77193,
	"./MessageSquare.vue": 10296,
	"./MessageSquareX.vue": 41636,
	"./MessageText.vue": 75885,
	"./Mobile.vue": 63090,
	"./PaperClip.vue": 89927,
	"./PasswordCheck.vue": 46700,
	"./Pencil.vue": 74161,
	"./Phone.vue": 99105,
	"./Play.vue": 67777,
	"./Plus.vue": 10593,
	"./PlusWhite.vue": 71905,
	"./RefreshCcw.vue": 73098,
	"./Repeat.vue": 32508,
	"./RotateCcw.vue": 79579,
	"./SandClock.vue": 58984,
	"./Save.vue": 89561,
	"./Search.vue": 9445,
	"./Services.vue": 43826,
	"./Setting.vue": 57203,
	"./Settings.vue": 38706,
	"./Settings2.vue": 39018,
	"./Share.vue": 16141,
	"./ShareEmail.vue": 89848,
	"./ShareFacebook.vue": 25573,
	"./ShareLinkedin.vue": 22028,
	"./ShareTelegram.vue": 84000,
	"./ShareTwitter.vue": 30206,
	"./ShareViber.vue": 95973,
	"./ShareWhatsapp.vue": 81431,
	"./Shield.vue": 71309,
	"./SidebarCollapse.vue": 82392,
	"./SidebarExpand.vue": 69404,
	"./Star.vue": 96442,
	"./StarGradient.vue": 64637,
	"./StarLarge.vue": 61771,
	"./StatusActive.vue": 44896,
	"./StatusBlocked.vue": 79157,
	"./StatusCheck.vue": 47678,
	"./StatusFailed.vue": 80535,
	"./StatusProcess.vue": 6413,
	"./StatusWaitingModeration.vue": 74422,
	"./StatusWaitingSign.vue": 53123,
	"./StepCheck.vue": 22667,
	"./StepTriger.vue": 89125,
	"./StickyNote.vue": 6723,
	"./Table.vue": 1386,
	"./Task.vue": 63335,
	"./TaskGradient.vue": 6142,
	"./Telegram.vue": 89751,
	"./Trash.vue": 13412,
	"./TypeB1.vue": 68377,
	"./TypeB2.vue": 4634,
	"./TypeB3.vue": 66187,
	"./TypeB4.vue": 89771,
	"./User.vue": 74098,
	"./UserGradient.vue": 40160,
	"./Viber.vue": 10365,
	"./Whatsapp.vue": 89618,
	"./Zoom.vue": 24067
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25672;